export enum Envs {
	Production = 'production',
	Staging = 'staging',
	Develop = 'develop',
	Local = 'local',
}

export type Env = Envs.Production | Envs.Staging | Envs.Develop | Envs.Local;
